module.exports = __webpack_public_path__ + "static/2front-mobile-3-d89ea6be803d8efbf7807f1b6ebc0214.png";